import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { APP_SETTINGS, UtilityService } from '@services';

@Pipe({ name: 'brandTypePipe' })
export class BrandTypePipe implements PipeTransform {

  public brandType = false;

  constructor(private utilityService: UtilityService, private changeDetectorRef: ChangeDetectorRef) { }

  transform(value: any, args?: any): any {

    this.brandType = APP_SETTINGS.brandType === "true";
    return this.brandType;
  }

}
